import { render, staticRenderFns } from "./goodSeries.vue?vue&type=template&id=6c48cec6&scoped=true&"
import script from "./goodSeries.vue?vue&type=script&lang=js&"
export * from "./goodSeries.vue?vue&type=script&lang=js&"
import style0 from "./goodSeries.vue?vue&type=style&index=0&id=6c48cec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c48cec6",
  null
  
)

export default component.exports